import { lazy, ComponentType } from "preact/compat";

type LazyComponentMap = Record<string, ComponentType<any>>;

export const componentMap: LazyComponentMap = {
  ExpandableList: lazy(
    () => import("../components/ExpandableList/ExpandableList")
  ),
  GraphicSwipe: lazy(() => import("../components/GraphicSwipe/GraphicSwipe")),
  VideoPlayer: lazy(() => import("../components/VideoPlayer/VideoPlayer")),
  TeaserCounter: lazy(() => import("../components/TeaserCounter/TeaserCounter")),
  CarbonBudget: lazy(() => import("../components/CarbonBudget/CarbonBudget")),
  IncomeTax: lazy(() => import("../components/IncomeTax/IncomeTax")),
  LinkBoxCampaign: lazy(() => import("../components/LinkBoxCampaign/LinkBoxCampaign")
  ),
};

export const componentNames = Object.keys(componentMap);
